/**
 * Overview 우측 정보 패널의 폭 선언 — 한 곳.
 *
 * 상한은 고정값이 아니라 **남는 자리**다: 본문 행(메인+패널)의 폭에서 메인이 지켜야 할
 * 최소폭을 뺀 값을 패널의 [min, max] 안으로 접는다. 앱 사이드바가 접히면 자리가 늘어 그만큼
 * 넓힐 수 있고, 좁은 창에서는 메인이 먼저다. 행 폭을 아직 모르면(첫 렌더·측정 불가) 절대
 * 상한을 쓴다. 옛 방식(lg 에서 340 고정 CSS 캡)은 자리가 남아도 넓힐 수 없었고 훅의 픽셀
 * 상태와 렌더 폭이 어긋났다(3차 베타 L-1).
 */
export const SIDE_PANEL_WIDTH = {
  default: 340,
  min: 260,
  /** 절대 상한 — 이보다 넓은 정보 패널은 없다 */
  max: 480,
  /** 패널이 펼쳐진 상태에서 메인(진입 카드+게시판)이 지켜야 할 최소폭 */
  mainMin: 600,
} as const;

export function sidePanelMaxWidth(bodyRowWidth: number | null): number {
  if (bodyRowWidth === null) return SIDE_PANEL_WIDTH.max;
  const room = bodyRowWidth - SIDE_PANEL_WIDTH.mainMin;
  return Math.max(SIDE_PANEL_WIDTH.min, Math.min(SIDE_PANEL_WIDTH.max, room));
}
